import classNames from "classnames";
import MuiTable, { IRowProps, TableColumn, TableHeightMode } from "./MuiTable";
import SearchBarTable from "./SearchBarTable";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import { useCallback, useRef, useState } from "react";

type ISelectOption = {
	value: string;
	label: string;
};

type IProps = {
	columnsHead: readonly TableColumn[];
	rows: IRowProps[];
	count?: number;
	placeholderSearchbar?: string;
	className?: string;
	searchbarDisabled?: boolean;
	heightMode?: TableHeightMode;
	viewportBottomMargin?: number;
	onNext: ((release: () => void, reset?: () => void) => Promise<void> | void) | null;
	onSearch?: (search: string, selectedFilter?: string) => void;
	selectOptions?: ISelectOption[];
	selectPlaceholder?: string;
};

/**
 * @TODO Enable fit content on collumn (column sized props in collumn definition)
 */
export default function Table(props: IProps) {
	const { className, columnsHead, rows, placeholderSearchbar, searchbarDisabled, onSearch: propOnSearch, selectOptions, selectPlaceholder } = props;
	const keyId = useRef<number>(0);
	const [search, setSearch] = useState<string>("");
	const [selectedFilter, setSelectedFilter] = useState<string>("");

	const onSearch = useCallback(
		(search: string) => {
			keyId.current++;
			setSearch(search);
			propOnSearch?.(search);
		},
		[propOnSearch],
	);

	const onSelectChange = useCallback(
		(e: React.ChangeEvent<HTMLSelectElement>) => {
			keyId.current++;
			const value = e.target.value;
			setSelectedFilter(value);
			propOnSearch?.(search, value);
		},
		[propOnSearch, search],
	);

	return (
		<div className={classNames(classes["root"], className)}>
			{!searchbarDisabled && (
				<div className={classes["header"]}>
					<div>
						{props.count ?? rows.length} {I18n.asset.common.results}
					</div>
					<div className={classes["input-container"]}>
						{selectOptions && selectOptions.length > 0 && (
							<select onChange={onSelectChange} value={selectedFilter} className={classes["select"]} name="creator-filter" id="creator-filter">
								<option value="">{selectPlaceholder || "Tous"}</option>
								{selectOptions.map((option) => (
									<option key={option.value} value={option.value}>
										{option.label}
									</option>
								))}
							</select>
						)}
						<SearchBarTable onChange={onSearch} placeholder={placeholderSearchbar ?? ""} />
					</div>
				</div>
			)}

			<MuiTable
				key={keyId.current}
				columnsHead={columnsHead}
				rows={rows}
				onNext={props.onNext}
				heightMode={props.heightMode}
				viewportBottomMargin={props.viewportBottomMargin}
			/>
		</div>
	);
}
